import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import CircularProgress from '@mui/material/CircularProgress'
import Badge from '@mui/material/Badge'
import Menu from '@mui/material/Menu'
import MenuList from '@mui/material/MenuList'
import ListItemText from '@mui/material/ListItemText'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import AttachFile from '@mui/icons-material/AttachFile'
import ArrowBack from '@mui/icons-material/ArrowBack'
import LogoutIcon from '@mui/icons-material/ExitToApp'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import NotificationsIcon from '@mui/icons-material/Notifications'

const RestTunel = require('../../libs/rest_tunnel')
const session = require('../../config/session')
const ExcelJS = require('exceljs')
const FileSaver = require('file-saver')

const ESTADOS = ['Nueva', 'Recibida', 'En revisión', 'En proceso', 'Pendiente de información', 'Solucionada', 'Cerrada']
const CATEGORIAS = [
  'Billetero/aceptación de billetes', 'Depósito y transacción', 'Bóveda y cerradura', 'Bolsa/cashbox',
  'Comunicación y conectividad', 'Impresora', 'Equipo fuera de servicio', 'Usuarios, funcionarios y depositantes',
  'Apertura de bóveda/transportadora', 'Reportes y datos', 'Mantenimiento correctivo', 'Consultas y solicitudes administrativas'
]
const COLOR_ESTADO = {
  'Nueva': 'info', 'Recibida': 'info', 'En revisión': 'warning', 'En proceso': 'primary',
  'Pendiente de información': 'warning', 'Solucionada': 'success', 'Cerrada': 'default'
}
const BANDEJAS = [
  { key: '', label: 'Todas', c: 'todas' },
  { key: 'nuevas', label: 'Nuevas', c: 'nuevas' },
  { key: 'sin_asignar', label: 'Sin asignar', c: 'sin_asignar' },
  { key: 'mias', label: 'Las que llevo', c: 'mias' },
  { key: 'en_proceso', label: 'En proceso', c: 'en_proceso' },
  { key: 'pendientes', label: 'Pendientes', c: 'pendientes' },
  { key: 'sla_riesgo', label: 'SLA en riesgo', c: 'sla_riesgo' },
  { key: 'sla_vencido', label: 'SLA vencido', c: 'sla_vencido' },
  { key: 'solucionadas', label: 'Solucionadas', c: 'solucionadas' }
]

class SoporteConsolaPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      view: 'list', selectedId: null,
      bandeja: '', filtros: { estado: '', tipo: '', categoria: '', severidad: '', id_entidad: '', responsable_id: '', cajero_codigo: '', fecha_inicio: '', fecha_fin: '' },
      solicitudes: [], bandejas: {}, cargandoList: true,
      opciones: { entidades: [], responsables: [] },
      caso: null, conversacion: [], cargandoDetalle: false,
      e_estado: '', e_severidad: '', e_categoria: '', e_escalamiento: '', e_responsable: '',
      contenido: '', archivo: null, enviando: false,
      notificaciones: [], notifAnchor: null,
      contexto: null, cargandoContexto: false,
      reportes: null, cargandoReportes: false, repFiltros: { id_entidad: '', fecha_inicio: '', fecha_fin: '' },
      config: null,
      snack: { open: false, severity: 'success', msg: '' }
    }
  }

  componentDidMount() {
    if (!session.isAuthorized('acceder_soporte_panel')) return
    this.cargarOpciones()
    this.cargarLista()
    this.cargarNotificaciones()
    this.notifTimer = setInterval(this.cargarNotificaciones, 30000)
  }

  componentWillUnmount() { if (this.notifTimer) clearInterval(this.notifTimer) }

  cargarNotificaciones = () => {
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: {}, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/notificaciones' },
      (err, data) => { if (!err) this.setState({ notificaciones: data || [] }) })
  }

  marcarNotif = (id, solicitudId) => {
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: { id: id }, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/notificaciones/leer' },
      () => { this.cargarNotificaciones() })
    this.setState({ notifAnchor: null })
    if (solicitudId) this.abrirCaso(solicitudId)
  }

  marcarTodasNotif = () => {
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: { todas: true }, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/notificaciones/leer' },
      () => { this.cargarNotificaciones() })
    this.setState({ notifAnchor: null })
  }

  toggleBandera = (bandera, valor) => {
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: { solicitud_id: this.state.caso.id, bandera: bandera, valor: valor ? 1 : 0 }, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/banderas' },
      (err, data) => { if (err) return this.avisar('error', (data && data.message) || 'No se pudo cambiar'); this.abrirCaso(this.state.caso.id) })
  }

  irA = (view) => {
    this.setState({ view: view })
    if (view === 'reportes') this.cargarReportes()
    if (view === 'config') this.cargarConfig()
    if (view === 'list') this.cargarLista()
  }

  cargarReportes = () => {
    this.setState({ cargandoReportes: true })
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: this.state.repFiltros, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/reportes' },
      (err, data) => this.setState({ cargandoReportes: false, reportes: err ? null : data }))
  }

  exportarReportes = () => {
    const r = this.state.reportes
    if (!r) return
    const R = r.resumen || {}
    const pctFR = R.con_primera ? Math.round(100 * R.primera_en_sla / R.con_primera) : 0
    const pctRes = R.resueltas ? Math.round(100 * R.resueltas_en_sla / R.resueltas) : 0
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet('Resumen')
    ws.columns = [{ header: 'Métrica', key: 'm', width: 40 }, { header: 'Valor', key: 'v', width: 20 }]
    ;[['Total', R.total], ['Abiertas', R.abiertas], ['Cerradas', R.cerradas], ['Solucionadas', R.solucionadas],
      ['Escalados', R.escalados], ['Servicios fallidos', R.servicios_fallidos], ['Reabiertas', R.reabiertas],
      ['% 1ª respuesta en SLA', pctFR + '%'], ['% resolución en SLA', pctRes + '%'], ['Vencidas ahora', R.vencidas_ahora],
      ['Prom. 1ª respuesta (min)', Math.round(R.prom_primera_min || 0)], ['Prom. resolución (min)', Math.round(R.prom_resolucion_min || 0)]
    ].forEach(x => ws.addRow({ m: x[0], v: x[1] }))
    const hoja = (nombre, cols, rows) => { const w = wb.addWorksheet(nombre); w.columns = cols; (rows || []).forEach(x => w.addRow(x)) }
    hoja('Por categoria', [{ header: 'Categoría', key: 'categoria', width: 40 }, { header: 'Total', key: 'total', width: 10 }, { header: 'Cerradas', key: 'cerradas', width: 10 }], r.por_categoria)
    hoja('Por entidad', [{ header: 'Entidad', key: 'entidad', width: 30 }, { header: 'Total', key: 'total', width: 10 }, { header: 'Cerradas', key: 'cerradas', width: 10 }], r.por_entidad)
    hoja('Por severidad', [{ header: 'Severidad', key: 'severidad', width: 12 }, { header: 'Total', key: 'total', width: 10 }, { header: 'Cerradas', key: 'cerradas', width: 10 }], r.por_severidad)
    hoja('Carga responsable', [{ header: 'Responsable', key: 'responsable', width: 30 }, { header: 'Abiertos', key: 'abiertos', width: 10 }], r.carga_responsable)
    hoja('Recurrentes', [{ header: 'Cajero', key: 'cajero', width: 16 }, { header: 'Categoría', key: 'categoria', width: 40 }, { header: 'Casos', key: 'n', width: 8 }], r.recurrentes)
    wb.xlsx.writeBuffer().then(buf => FileSaver.saveAs(new Blob([buf]), 'reporte_soporte.xlsx'))
  }

  cargarConfig = () => {
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: {}, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/config-get' },
      (err, data) => {
        if (err || !data) return this.avisar('error', 'No se pudo cargar la configuración')
        const d = data.destinatarios || (data.alertas && data.alertas.destinatarios) || {}
        this.setState({
          config: {
            sla: data.sla || { severidades: {} },
            alertas: data.alertas || {},
            _agente: ((data.alertas && data.alertas.destinatarios && data.alertas.destinatarios.agente) || []).join(', '),
            _coordinador: ((data.alertas && data.alertas.destinatarios && data.alertas.destinatarios.coordinador) || []).join(', '),
            _direccion: ((data.alertas && data.alertas.destinatarios && data.alertas.destinatarios.direccion) || []).join(', ')
          }
        })
      })
  }

  setCfg = (mut) => { const c = JSON.parse(JSON.stringify(this.state.config)); mut(c); this.setState({ config: c }) }

  guardarConfig = () => {
    const c = this.state.config
    const split = (s) => String(s || '').split(',').map(x => x.trim()).filter(x => x)
    const payload = {
      sla: c.sla,
      alertas: {
        porcentaje_riesgo_resolucion: c.alertas.porcentaje_riesgo_resolucion,
        recurrente_periodo_dias: c.alertas.recurrente_periodo_dias,
        destinatarios: { agente: split(c._agente), coordinador: split(c._coordinador), direccion: split(c._direccion) }
      }
    }
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: payload, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/config-set' },
      (err, data) => { if (err) return this.avisar('error', (data && data.message) || 'No se pudo guardar'); this.avisar('success', 'Configuración guardada') })
  }

  avisar = (severity, msg) => this.setState({ snack: { open: true, severity, msg } })

  cargarOpciones = () => {
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: {}, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/opciones' },
      (err, data) => { if (!err) this.setState({ opciones: { entidades: data.entidades || [], responsables: data.responsables || [] } }) })
  }

  cargarLista = () => {
    const s = this.state
    this.setState({ cargandoList: true })
    RestTunel.makePetition({
      method: 'POST', headers: 'JSON',
      body: Object.assign({ bandeja: s.bandeja }, s.filtros),
      url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/list'
    }, (err, data) => {
      if (err) { this.setState({ cargandoList: false }); return this.avisar('error', (data && data.message) || 'Error consultando') }
      this.setState({ solicitudes: data.solicitudes || [], bandejas: data.bandejas || {}, cargandoList: false })
    })
  }

  cargarContexto = () => {
    this.setState({ cargandoContexto: true })
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: { solicitud_id: this.state.caso.id }, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/contexto-cajero' },
      (err, data) => { this.setState({ cargandoContexto: false, contexto: err ? null : data }); if (err) this.avisar('error', 'No se pudo cargar el contexto') })
  }

  abrirCaso = (id) => {
    this.setState({ view: 'detalle', selectedId: id, cargandoDetalle: true, caso: null, conversacion: [], contexto: null })
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: { solicitud_id: id }, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/detalle' },
      (err, data) => {
        if (err) { this.setState({ cargandoDetalle: false }); return this.avisar('error', (data && data.message) || 'No se pudo abrir') }
        const c = data.caso
        this.setState({
          caso: c, conversacion: data.conversacion || [], cargandoDetalle: false,
          e_estado: c.estado, e_severidad: c.severidad, e_categoria: c.categoria || '',
          e_escalamiento: c.escalamiento || '', e_responsable: c.responsable_id || ''
        })
      })
  }

  volver = () => { this.setState({ view: 'list', selectedId: null, caso: null }); this.cargarLista() }
  setFiltro = (campo) => (e) => this.setState({ filtros: Object.assign({}, this.state.filtros, { [campo]: e.target.value }) })
  elegirBandeja = (key) => this.setState({ bandeja: key }, this.cargarLista)

  guardarGestion = () => {
    const s = this.state, c = s.caso
    const body = { solicitud_id: c.id, estado: s.e_estado, severidad: s.e_severidad, escalamiento: s.e_escalamiento }
    if (c.tipo === 'maquina' && s.e_categoria) body.categoria = s.e_categoria
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: body, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/estado' },
      (err, data) => {
        if (err) return this.avisar('error', (data && data.message) || 'No se pudo guardar')
        this.avisar('success', 'Cambios guardados'); this.abrirCaso(c.id)
      })
  }

  asignar = () => {
    const s = this.state
    if (!s.e_responsable) return this.avisar('warning', 'Selecciona un responsable')
    RestTunel.makePetition({ method: 'POST', headers: 'JSON', body: { solicitud_id: s.caso.id, responsable_id: s.e_responsable }, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/asignar' },
      (err, data) => {
        if (err) return this.avisar('error', (data && data.message) || 'No se pudo asignar')
        this.avisar('success', 'Asignado'); this.abrirCaso(s.caso.id)
      })
  }

  responder = () => {
    const s = this.state
    if ((!s.contenido || !s.contenido.trim()) && !s.archivo) return this.avisar('warning', 'Escribe un mensaje')
    const fd = new FormData()
    fd.append('solicitud_id', s.caso.id); fd.append('contenido', s.contenido)
    if (s.archivo) fd.append('adjunto', s.archivo)
    this.setState({ enviando: true })
    RestTunel.makePetition({ method: 'POST', body: fd, url: process.env.REACT_APP_URL_BACKEND + '/soporte/panel/responder' },
      (err, data) => {
        this.setState({ enviando: false })
        if (err) return this.avisar('error', (data && data.message) || 'No se pudo enviar')
        this.setState({ contenido: '', archivo: null }); this.abrirCaso(s.caso.id)
      })
  }

  descargarAdjunto = (m) => {
    fetch(process.env.REACT_APP_URL_BACKEND + '/soporte/adjunto', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'x-access-token': '' + session.getToken(), 'dashboard-version': '' + process.env.REACT_APP_VERSION },
      body: JSON.stringify({ mensaje_id: m.id })
    }).then(r => {
      const ct = r.headers.get('content-type') || ''
      if (ct.indexOf('application/json') !== -1) return r.json().then(() => { throw new Error('json') })
      return r.blob()
    }).then(blob => { const url = URL.createObjectURL(blob); window.open(url, '_blank'); setTimeout(() => URL.revokeObjectURL(url), 60000) })
      .catch(() => this.avisar('error', 'No se pudo abrir el adjunto'))
  }

  header() {
    const s = this.state
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1, bgcolor: '#1f2a44', color: '#fff' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SupportAgentIcon /><Typography variant="h6">Soporte SSC</Typography>
        </Box>
        <Box>
          <IconButton color="inherit" title="Alertas" onClick={(e) => this.setState({ notifAnchor: e.currentTarget })}>
            <Badge badgeContent={s.notificaciones.length} color="error"><NotificationsIcon /></Badge>
          </IconButton>
          <Menu anchorEl={s.notifAnchor} open={Boolean(s.notifAnchor)} onClose={() => this.setState({ notifAnchor: null })}>
            {s.notificaciones.length === 0 && <MenuItem disabled>Sin alertas</MenuItem>}
            {s.notificaciones.map(n => (
              <MenuItem key={n.id} onClick={() => this.marcarNotif(n.id, n.solicitud_id)}>
                <ListItemText primary={n.mensaje} secondary={n.fecha_creacion} />
              </MenuItem>
            ))}
            {s.notificaciones.length > 0 && <MenuItem onClick={this.marcarTodasNotif}><em>Marcar todas como leídas</em></MenuItem>}
          </Menu>
          <IconButton color="inherit" component={Link} to={'/logout/' + (session.getItem('entidad_tag') || 'automated')} title="Salir"><LogoutIcon /></IconButton>
        </Box>
      </Box>
    )
  }

  renderMensaje = (m) => {
    if (m.tipo === 'evento') {
      return <Box key={m.id} sx={{ textAlign: 'center', my: 1 }}><Typography variant="caption" color="text.secondary">— {m.contenido} · {m.fecha_creacion} —</Typography></Box>
    }
    const esSsc = m.origen === 'ssc'
    return (
      <Box key={m.id} sx={{ display: 'flex', justifyContent: esSsc ? 'flex-end' : 'flex-start', my: 1 }}>
        <Paper sx={{ p: 1.5, maxWidth: '75%', bgcolor: esSsc ? '#E8F5E9' : '#F1F1F1' }}>
          <Typography variant="caption" color="text.secondary">{esSsc ? (m.autor || 'SSC') : 'Cliente'} · {m.fecha_creacion}</Typography>
          {m.contenido && <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mt: 0.5 }}>{m.contenido}</Typography>}
          {m.tiene_adjunto === 1 && <Button size="small" startIcon={<AttachFile />} onClick={() => this.descargarAdjunto(m)} sx={{ mt: 0.5, textTransform: 'none' }}>{m.adjunto_nombre || 'Ver adjunto'}</Button>}
        </Paper>
      </Box>
    )
  }

  renderLista() {
    const s = this.state
    return (
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 1 }}>
          {session.checkPermiso('acceder_soporte_panel') && <Button size="small" variant="outlined" onClick={() => this.irA('reportes')}>Reportes</Button>}
          {session.checkPermiso('acceder_soporte_panel') && <Button size="small" variant="outlined" onClick={() => this.irA('config')}>Configuración</Button>}
        </Box>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
          {BANDEJAS.map(b => (
            <Chip key={b.key} label={b.label + ' (' + (s.bandejas[b.c] || 0) + ')'} color={s.bandeja === b.key ? 'primary' : 'default'}
              onClick={() => this.elegirBandeja(b.key)} variant={s.bandeja === b.key ? 'filled' : 'outlined'} />
          ))}
        </Box>

        <Paper sx={{ p: 2, mb: 2 }}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={2}><FormControl fullWidth size="small"><InputLabel>Estado</InputLabel><Select label="Estado" value={s.filtros.estado} onChange={this.setFiltro('estado')}><MenuItem value="">Todos</MenuItem>{ESTADOS.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}</Select></FormControl></Grid>
            <Grid item xs={6} sm={2}><FormControl fullWidth size="small"><InputLabel>Tipo</InputLabel><Select label="Tipo" value={s.filtros.tipo} onChange={this.setFiltro('tipo')}><MenuItem value="">Todos</MenuItem><MenuItem value="maquina">Máquina</MenuItem><MenuItem value="plataforma">Plataforma</MenuItem></Select></FormControl></Grid>
            <Grid item xs={6} sm={2}><FormControl fullWidth size="small"><InputLabel>Severidad</InputLabel><Select label="Severidad" value={s.filtros.severidad} onChange={this.setFiltro('severidad')}><MenuItem value="">Todas</MenuItem><MenuItem value={1}>Nivel 1</MenuItem><MenuItem value={2}>Nivel 2</MenuItem><MenuItem value={3}>Nivel 3</MenuItem></Select></FormControl></Grid>
            <Grid item xs={6} sm={3}><FormControl fullWidth size="small"><InputLabel>Entidad</InputLabel><Select label="Entidad" value={s.filtros.id_entidad} onChange={this.setFiltro('id_entidad')}><MenuItem value="">Todas</MenuItem>{s.opciones.entidades.map(e => <MenuItem key={e.id} value={e.id}>{e.nombre}</MenuItem>)}</Select></FormControl></Grid>
            <Grid item xs={6} sm={3}><FormControl fullWidth size="small"><InputLabel>Responsable</InputLabel><Select label="Responsable" value={s.filtros.responsable_id} onChange={this.setFiltro('responsable_id')}><MenuItem value="">Todos</MenuItem>{s.opciones.responsables.map(r => <MenuItem key={r.id} value={r.id}>{r.nombre}</MenuItem>)}</Select></FormControl></Grid>
            <Grid item xs={6} sm={2}><TextField fullWidth size="small" label="Cajero" value={s.filtros.cajero_codigo} onChange={this.setFiltro('cajero_codigo')} /></Grid>
            <Grid item xs={6} sm={2}><TextField fullWidth size="small" type="date" label="Desde" InputLabelProps={{ shrink: true }} value={s.filtros.fecha_inicio} onChange={this.setFiltro('fecha_inicio')} /></Grid>
            <Grid item xs={6} sm={2}><TextField fullWidth size="small" type="date" label="Hasta" InputLabelProps={{ shrink: true }} value={s.filtros.fecha_fin} onChange={this.setFiltro('fecha_fin')} /></Grid>
            <Grid item xs={6} sm={2}><Button fullWidth variant="outlined" onClick={this.cargarLista}>Buscar</Button></Grid>
          </Grid>
        </Paper>

        <Paper>
          {s.cargandoList ? <Box sx={{ p: 3, textAlign: 'center' }}><CircularProgress /></Box> :
          <Table size="small">
            <TableHead><TableRow>
              <TableCell>N°</TableCell><TableCell>Entidad</TableCell><TableCell>Cajero/Módulo</TableCell>
              <TableCell>Categoría</TableCell><TableCell>Sev.</TableCell><TableCell>Estado</TableCell>
              <TableCell>SLA</TableCell><TableCell>Responsable</TableCell><TableCell>Actualizado</TableCell>
            </TableRow></TableHead>
            <TableBody>
              {s.solicitudes.length === 0 && <TableRow><TableCell colSpan={9} align="center">Sin solicitudes</TableCell></TableRow>}
              {s.solicitudes.map(r => (
                <TableRow key={r.id} hover sx={{ cursor: 'pointer' }} onClick={() => this.abrirCaso(r.id)}>
                  <TableCell>{r.sup}{r.bandera_reabierta ? ' ↺' : ''}{r.bandera_escalada ? ' ⬆' : ''}</TableCell>
                  <TableCell>{r.entidad_nombre || '-'}</TableCell>
                  <TableCell>{r.tipo === 'maquina' ? (r.cajero_codigo || '-') : (r.modulo || '-')}</TableCell>
                  <TableCell>{r.categoria || '-'}</TableCell>
                  <TableCell>{r.severidad}</TableCell>
                  <TableCell><Chip size="small" label={r.estado} color={COLOR_ESTADO[r.estado] || 'default'} /></TableCell>
                  <TableCell>
                    {(r.sla_respuesta_vencida || r.sla_resolucion_vencida) ? <Chip size="small" color="error" label="Vencido" />
                      : r.sla_resolucion_riesgo ? <Chip size="small" color="warning" label="Riesgo" />
                      : <span style={{ color: '#999' }}>—</span>}
                  </TableCell>
                  <TableCell>{r.responsable_nombre || <em style={{ color: '#b26a00' }}>sin asignar</em>}</TableCell>
                  <TableCell>{r.fecha_actualizacion || r.fecha_creacion}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>}
        </Paper>
      </Box>
    )
  }

  renderDetalle() {
    const s = this.state
    if (s.cargandoDetalle) return <Box sx={{ p: 4, textAlign: 'center' }}><CircularProgress /></Box>
    const c = s.caso
    if (!c) return <Box sx={{ p: 3 }}><Button startIcon={<ArrowBack />} onClick={this.volver}>Volver</Button><Typography>No se encontró el caso.</Typography></Box>
    const puedeEstado = session.checkPermiso('acceder_soporte_panel')
    const puedeAsignar = session.checkPermiso('acceder_soporte_panel')
    const puedeResponder = session.checkPermiso('acceder_soporte_panel')
    const puedeBanderas = session.checkPermiso('acceder_soporte_panel')
    const cerrada = c.estado === 'Cerrada'

    return (
      <Box sx={{ p: 2 }}>
        <Button startIcon={<ArrowBack />} onClick={this.volver} sx={{ mb: 1 }}>Volver a la lista</Button>
        <Grid container spacing={2}>
          <Grid item xs={12} md={7}>
            <Paper sx={{ p: 2, mb: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <Typography variant="h6">{c.sup}</Typography>
                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                  <Chip size="small" label={c.estado} color={COLOR_ESTADO[c.estado] || 'default'} />
                  {c.bandera_reabierta ? <Chip size="small" label="Reabierta" /> : null}
                  {c.bandera_escalada ? <Chip size="small" color="error" label="Escalada" /> : null}
                  {c.bandera_critica ? <Chip size="small" color="error" label="Crítica" /> : null}
                </Box>
              </Box>
              <Grid container spacing={1} sx={{ mt: 0.5 }}>
                <Grid item xs={6}><Typography variant="body2"><b>Entidad:</b> {c.entidad_nombre}</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2"><b>Reporta:</b> {c.reporta_nombre}</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2"><b>Tipo:</b> {c.tipo === 'maquina' ? 'Máquina' : 'Plataforma'}</Typography></Grid>
                <Grid item xs={6}><Typography variant="body2"><b>{c.tipo === 'maquina' ? 'Cajero' : 'Módulo'}:</b> {c.tipo === 'maquina' ? (c.cajero_codigo || '-') : (c.modulo || '-')}</Typography></Grid>
                <Grid item xs={12}><Divider sx={{ my: 1 }} /><Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}><b>Descripción:</b> {c.descripcion}</Typography></Grid>
                {c.info_adicional && <Grid item xs={12}><Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}><b>Info adicional:</b> {c.info_adicional}</Typography></Grid>}
              </Grid>
            </Paper>

            <Paper sx={{ p: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Conversación</Typography>
              <Box sx={{ maxHeight: 360, overflowY: 'auto', px: 1 }}>
                {s.conversacion.map(this.renderMensaje)}
              </Box>
              {!cerrada && puedeResponder &&
                <Box sx={{ mt: 2 }}>
                  <Divider sx={{ mb: 2 }} />
                  <TextField fullWidth multiline minRows={2} placeholder="Responder al cliente…" value={s.contenido} onChange={(e) => this.setState({ contenido: e.target.value })} inputProps={{ maxLength: 5000 }} />
                  <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
                    <Button variant="outlined" component="label" startIcon={<AttachFile />} sx={{ textTransform: 'none' }}>{s.archivo ? s.archivo.name : 'Adjuntar'}<input type="file" hidden accept="image/*,application/pdf" onChange={(e) => this.setState({ archivo: e.target.files[0] || null })} /></Button>
                    <Button variant="contained" disabled={s.enviando} onClick={this.responder}>{s.enviando ? 'Enviando…' : 'Enviar'}</Button>
                  </Box>
                </Box>}
            </Paper>
          </Grid>

          <Grid item xs={12} md={5}>
            <Paper sx={{ p: 2, mb: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Gestión</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth size="small" disabled={!puedeAsignar}>
                    <InputLabel>Responsable</InputLabel>
                    <Select label="Responsable" value={s.e_responsable} onChange={(e) => this.setState({ e_responsable: e.target.value })}>
                      <MenuItem value=""><em>Sin asignar</em></MenuItem>
                      {s.opciones.responsables.map(r => <MenuItem key={r.id} value={r.id}>{r.nombre}</MenuItem>)}
                    </Select>
                  </FormControl>
                  {puedeAsignar && <Button size="small" sx={{ mt: 1 }} variant="outlined" onClick={this.asignar}>Asignar</Button>}
                </Grid>
                <Grid item xs={12}><Divider /></Grid>
                <Grid item xs={6}><FormControl fullWidth size="small" disabled={!puedeEstado}><InputLabel>Estado</InputLabel><Select label="Estado" value={s.e_estado} onChange={(e) => this.setState({ e_estado: e.target.value })}>{ESTADOS.map(e => <MenuItem key={e} value={e}>{e}</MenuItem>)}</Select></FormControl></Grid>
                <Grid item xs={6}><FormControl fullWidth size="small" disabled={!puedeEstado}><InputLabel>Severidad</InputLabel><Select label="Severidad" value={s.e_severidad} onChange={(e) => this.setState({ e_severidad: e.target.value })}><MenuItem value={1}>Nivel 1</MenuItem><MenuItem value={2}>Nivel 2</MenuItem><MenuItem value={3}>Nivel 3</MenuItem></Select></FormControl></Grid>
                {c.tipo === 'maquina' &&
                  <Grid item xs={12}><FormControl fullWidth size="small" disabled={!puedeEstado}><InputLabel>Categoría</InputLabel><Select label="Categoría" value={s.e_categoria} onChange={(e) => this.setState({ e_categoria: e.target.value })}>{CATEGORIAS.map(cat => <MenuItem key={cat} value={cat}>{cat}</MenuItem>)}</Select></FormControl></Grid>}
                <Grid item xs={12}><FormControl fullWidth size="small" disabled={!puedeEstado}><InputLabel>Escalamiento</InputLabel><Select label="Escalamiento" value={s.e_escalamiento} onChange={(e) => this.setState({ e_escalamiento: e.target.value })}><MenuItem value="">Ninguno</MenuItem><MenuItem value="1">Nivel 1</MenuItem><MenuItem value="2">Nivel 2</MenuItem><MenuItem value="desarrollo">Desarrollo</MenuItem></Select></FormControl></Grid>
                {puedeEstado && <Grid item xs={12}><Button variant="contained" onClick={this.guardarGestion}>Guardar cambios</Button></Grid>}
                {puedeBanderas &&
                  <Grid item xs={12}>
                    <Divider sx={{ mb: 1 }} />
                    <Typography variant="caption" color="text.secondary">Banderas internas</Typography>
                    <FormGroup>
                      <FormControlLabel control={<Checkbox size="small" checked={!!c.bandera_critica} onChange={(e) => this.toggleBandera('critica', e.target.checked)} />} label="Crítica" />
                      <FormControlLabel control={<Checkbox size="small" checked={!!c.bandera_seguimiento} onChange={(e) => this.toggleBandera('seguimiento', e.target.checked)} />} label="Seguimiento" />
                      <FormControlLabel control={<Checkbox size="small" checked={!!c.bandera_cliente_sensible} onChange={(e) => this.toggleBandera('cliente_sensible', e.target.checked)} />} label="Cliente sensible" />
                    </FormGroup>
                  </Grid>}
              </Grid>
            </Paper>
            <Paper sx={{ p: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>SLA</Typography>
              <Typography variant="body2"><b>Creada:</b> {c.fecha_creacion}</Typography>
              <Typography variant="body2"><b>1ª respuesta:</b> {c.fecha_primera_respuesta || '— '}<span style={{ color: '#888' }}>(límite {c.limite_primera_respuesta || '—'})</span>{c.alerta_respuesta_vencida_at ? ' ⚠ alerta enviada' : ''}</Typography>
              <Typography variant="body2"><b>Resolución:</b> límite {c.limite_resolucion || '—'}{c.pausa_inicio ? ' (⏸ en pausa)' : ''}{c.tiempo_pausado_min ? ' · pausado ' + c.tiempo_pausado_min + ' min' : ''}</Typography>
              <Typography variant="body2"><b>Solucionada:</b> {c.fecha_solucion || '—'}</Typography>
              <Typography variant="body2"><b>Cerrada:</b> {c.fecha_cierre || '—'}</Typography>
              {(c.alerta_resolucion_80_at || c.alerta_resolucion_vencida_at) &&
                <Typography variant="caption" color="error">
                  {c.alerta_resolucion_80_at ? 'Alerta 80% enviada. ' : ''}{c.alerta_resolucion_vencida_at ? 'Alerta vencida enviada.' : ''}
                </Typography>}
            </Paper>
          </Grid>
        </Grid>

        <Paper sx={{ p: 2, mt: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1">
              {c.tipo === 'maquina' ? ('Contexto del cajero ' + (c.cajero_codigo ? '(' + c.cajero_codigo + ')' : '')) : 'Indicios (plataforma)'}
            </Typography>
            <Button size="small" variant="outlined" onClick={this.cargarContexto} disabled={s.cargandoContexto}>
              {s.cargandoContexto ? 'Cargando…' : (s.contexto ? 'Actualizar' : 'Cargar indicios')}
            </Button>
          </Box>
          {s.contexto && this.renderContexto(s.contexto)}
        </Paper>
      </Box>
    )
  }

  renderContexto(x) {
    const inst = x.instantanea || {}
    const errCajero = inst.eventos_error || []
    const errUsuario = inst.eventos_error_usuario || []
    const ev = x.ultimos_eventos || inst.ultimos_eventos || []
    const esPlataforma = inst.origen === 'plataforma'
    return (
      <Box sx={{ mt: 1 }}>
        {(errCajero.length > 0 || errUsuario.length > 0) &&
          <Paper variant="outlined" sx={{ p: 1.5, mb: 2, bgcolor: '#FFF4F4', borderColor: '#f5c2c2' }}>
            <Typography variant="subtitle2" color="error">Indicios: errores detectados al crear el caso</Typography>
            {errCajero.map((e, i) => <Typography key={'c' + i} variant="caption" display="block">{e.fecha_dispositivo} · {e.codigo} — {e.descripcion || e.detalle || ''}</Typography>)}
            {errUsuario.map((e, i) => <Typography key={'u' + i} variant="caption" display="block">{e.fecha} · {e.accion}{e.detalle ? ' — ' + e.detalle : ''}</Typography>)}
          </Paper>}
        {esPlataforma && errUsuario.length === 0 && <Typography variant="body2" color="text.secondary">Sin errores de plataforma registrados para el usuario.</Typography>}
        {!esPlataforma &&
      <Grid container spacing={2} sx={{ mt: 0.5 }}>
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle2">Estado actual</Typography>
          {x.cajero ? <>
            <Typography variant="body2"><b>Estado:</b> {x.cajero.estado} / {x.cajero.estado_operativo || '-'}</Typography>
            <Typography variant="body2"><b>Login:</b> {x.cajero.login_autorizado ? 'autorizado' : 'no'} · <b>Apertura:</b> {x.cajero.apertura_autorizada ? 'autorizada' : 'no'}</Typography>
          </> : <Typography variant="body2" color="text.secondary">Sin permiso para ver estado del cajero.</Typography>}
          {x.saldo != null && <Typography variant="body2"><b>Saldo sin recaudar:</b> {Number(x.saldo).toLocaleString('es-CO')}</Typography>}
          {x.instantanea && <Typography variant="caption" color="text.secondary">Instantánea al crear: {x.instantanea.capturado_at}</Typography>}
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle2">Últimos eventos</Typography>
          {ev.length === 0 && <Typography variant="body2" color="text.secondary">—</Typography>}
          {ev.slice(0, 8).map((e, i) => <Typography key={i} variant="caption" display="block">{e.fecha_dispositivo} · {e.codigo || ''} {e.descripcion || e.detalle || ''}</Typography>)}
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle2">Casos relacionados</Typography>
          {(x.relacionados || []).length === 0 && <Typography variant="body2" color="text.secondary">—</Typography>}
          {(x.relacionados || []).map(r => (
            <Typography key={r.id} variant="caption" display="block" sx={{ cursor: 'pointer', color: 'primary.main' }} onClick={() => this.abrirCaso(r.id)}>
              {r.sup} · {r.estado} · {r.categoria || ''}
            </Typography>
          ))}
          {x.ultimos_depositos && x.ultimos_depositos.length > 0 &&
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>Últimos depósitos: {x.ultimos_depositos.length} (rechazos: {x.ultimos_depositos.reduce((a, d) => a + (d.bill_rechazos || 0), 0)})</Typography>}
        </Grid>
      </Grid>}
      </Box>
    )
  }

  tablaRep(titulo, heads, rows) {
    return (
      <Paper sx={{ p: 1, mb: 1 }}>
        <Typography variant="subtitle2" sx={{ p: 1 }}>{titulo}</Typography>
        <Table size="small">
          <TableHead><TableRow>{heads.map((h, i) => <TableCell key={i}>{h}</TableCell>)}</TableRow></TableHead>
          <TableBody>
            {rows.length === 0 && <TableRow><TableCell colSpan={heads.length} align="center">—</TableCell></TableRow>}
            {rows.map((row, i) => <TableRow key={i}>{row.map((cell, j) => <TableCell key={j}>{cell}</TableCell>)}</TableRow>)}
          </TableBody>
        </Table>
      </Paper>
    )
  }

  renderReportes() {
    const s = this.state, r = s.reportes, R = (r && r.resumen) || {}
    const pctFR = R.con_primera ? Math.round(100 * R.primera_en_sla / R.con_primera) : 0
    const pctRes = R.resueltas ? Math.round(100 * R.resueltas_en_sla / R.resueltas) : 0
    return (
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h5">Reportes de soporte</Typography>
          <Box>
            <Button onClick={() => this.irA('list')} sx={{ mr: 1 }}>Volver a casos</Button>
            <Button variant="contained" onClick={this.exportarReportes} disabled={!r}>Exportar XLSX</Button>
          </Box>
        </Box>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={3}><FormControl fullWidth size="small"><InputLabel>Entidad</InputLabel><Select label="Entidad" value={s.repFiltros.id_entidad} onChange={e => this.setState({ repFiltros: { ...s.repFiltros, id_entidad: e.target.value } })}><MenuItem value="">Todas</MenuItem>{s.opciones.entidades.map(en => <MenuItem key={en.id} value={en.id}>{en.nombre}</MenuItem>)}</Select></FormControl></Grid>
            <Grid item xs={6} sm={3}><TextField fullWidth size="small" type="date" label="Desde" InputLabelProps={{ shrink: true }} value={s.repFiltros.fecha_inicio} onChange={e => this.setState({ repFiltros: { ...s.repFiltros, fecha_inicio: e.target.value } })} /></Grid>
            <Grid item xs={6} sm={3}><TextField fullWidth size="small" type="date" label="Hasta" InputLabelProps={{ shrink: true }} value={s.repFiltros.fecha_fin} onChange={e => this.setState({ repFiltros: { ...s.repFiltros, fecha_fin: e.target.value } })} /></Grid>
            <Grid item xs={6} sm={3}><Button fullWidth variant="outlined" onClick={this.cargarReportes}>Generar</Button></Grid>
          </Grid>
        </Paper>
        {s.cargandoReportes ? <CircularProgress /> : r &&
        <>
          <Grid container spacing={2} sx={{ mb: 2 }}>
            {[['Total', R.total], ['Abiertas', R.abiertas], ['Cerradas', R.cerradas], ['% 1ª resp. SLA', pctFR + '%'], ['% resol. SLA', pctRes + '%'], ['Vencidas ahora', R.vencidas_ahora], ['Escalados', R.escalados], ['Serv. fallidos', R.servicios_fallidos]].map((m, i) => (
              <Grid item xs={6} sm={3} key={i}><Paper sx={{ p: 2, textAlign: 'center' }}><Typography variant="h6">{m[1] != null ? m[1] : 0}</Typography><Typography variant="caption">{m[0]}</Typography></Paper></Grid>
            ))}
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>{this.tablaRep('Por categoría', ['Categoría', 'Total', 'Cerradas'], (r.por_categoria || []).map(x => [x.categoria, x.total, x.cerradas]))}</Grid>
            <Grid item xs={12} md={6}>{this.tablaRep('Por entidad', ['Entidad', 'Total', 'Cerradas'], (r.por_entidad || []).map(x => [x.entidad, x.total, x.cerradas]))}</Grid>
            <Grid item xs={12} md={6}>{this.tablaRep('Por severidad', ['Severidad', 'Total', 'Cerradas'], (r.por_severidad || []).map(x => ['Nivel ' + x.severidad, x.total, x.cerradas]))}</Grid>
            <Grid item xs={12} md={6}>{this.tablaRep('Carga por responsable', ['Responsable', 'Abiertos'], (r.carga_responsable || []).map(x => [x.responsable || 'Sin asignar', x.abiertos]))}</Grid>
            <Grid item xs={12}>{this.tablaRep('Recurrentes (cajero + categoría)', ['Cajero', 'Categoría', 'Casos'], (r.recurrentes || []).map(x => [x.cajero, x.categoria, x.n]))}</Grid>
          </Grid>
          <Typography variant="caption" color="text.secondary">Adopción: {r.adopcion ? r.adopcion.entidades : 0} entidades · {r.adopcion ? r.adopcion.usuarios : 0} usuarios · Prom. 1ª respuesta {Math.round(R.prom_primera_min || 0)} min · Prom. resolución {Math.round(R.prom_resolucion_min || 0)} min</Typography>
        </>}
      </Box>
    )
  }

  renderConfig() {
    const s = this.state, c = s.config
    if (!c) return <Box sx={{ p: 3 }}><Button onClick={() => this.irA('list')}>Volver</Button><CircularProgress sx={{ ml: 2 }} /></Box>
    const sev = (c.sla && c.sla.severidades) || {}
    const setSev = (k, campo, val) => this.setCfg(cc => { cc.sla.severidades = cc.sla.severidades || {}; cc.sla.severidades[k] = cc.sla.severidades[k] || {}; cc.sla.severidades[k][campo] = val })
    return (
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h5">Configuración de SLA y alertas</Typography>
          <Button onClick={() => this.irA('list')}>Volver a casos</Button>
        </Box>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>Tiempos por severidad</Typography>
          <Table size="small">
            <TableHead><TableRow><TableCell>Severidad</TableCell><TableCell>1ª respuesta (min)</TableCell><TableCell>Resolución (horas)</TableCell></TableRow></TableHead>
            <TableBody>{['1', '2', '3'].map(k => (
              <TableRow key={k}><TableCell>Nivel {k}</TableCell>
                <TableCell><TextField size="small" type="number" value={(sev[k] && sev[k].primera_respuesta_min) || ''} onChange={e => setSev(k, 'primera_respuesta_min', parseInt(e.target.value, 10))} /></TableCell>
                <TableCell><TextField size="small" type="number" value={(sev[k] && sev[k].resolucion_horas) || ''} onChange={e => setSev(k, 'resolucion_horas', parseInt(e.target.value, 10))} /></TableCell>
              </TableRow>))}
            </TableBody>
          </Table>
        </Paper>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>Alertas</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}><TextField fullWidth size="small" type="number" label="% riesgo resolución" value={c.alertas.porcentaje_riesgo_resolucion || ''} onChange={e => this.setCfg(cc => cc.alertas.porcentaje_riesgo_resolucion = parseInt(e.target.value, 10))} /></Grid>
            <Grid item xs={6} sm={3}><TextField fullWidth size="small" type="number" label="Días recurrencia" value={c.alertas.recurrente_periodo_dias || ''} onChange={e => this.setCfg(cc => cc.alertas.recurrente_periodo_dias = parseInt(e.target.value, 10))} /></Grid>
            <Grid item xs={12}><TextField fullWidth size="small" label="Correos coordinador (separa con comas)" value={c._coordinador} onChange={e => this.setCfg(cc => cc._coordinador = e.target.value)} /></Grid>
            <Grid item xs={12}><TextField fullWidth size="small" label="Correos dirección (separa con comas)" value={c._direccion} onChange={e => this.setCfg(cc => cc._direccion = e.target.value)} /></Grid>
            <Grid item xs={12}><TextField fullWidth size="small" label="Correos agente (separa con comas)" value={c._agente} onChange={e => this.setCfg(cc => cc._agente = e.target.value)} /></Grid>
          </Grid>
        </Paper>
        <Button variant="contained" onClick={this.guardarConfig}>Guardar configuración</Button>
      </Box>
    )
  }

  render() {
    if (!session.isAuthorized('acceder_soporte_panel')) return <Redirect to="/entidad/automated" />
    const s = this.state
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: '#f4f6f8' }}>
        {this.header()}
        {s.view === 'list' ? this.renderLista()
          : s.view === 'detalle' ? this.renderDetalle()
          : s.view === 'reportes' ? this.renderReportes()
          : s.view === 'config' ? this.renderConfig()
          : this.renderLista()}
        <Snackbar open={s.snack.open} autoHideDuration={4000} onClose={() => this.setState({ snack: { ...s.snack, open: false } })} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
          <Alert severity={s.snack.severity} onClose={() => this.setState({ snack: { ...s.snack, open: false } })}>{s.snack.msg}</Alert>
        </Snackbar>
      </Box>
    )
  }
}

export default SoporteConsolaPage
